import Home from "./routes/home";
import About from "./routes/about";
import Fonts from "./routes/fonts";
import SkillGraph from "./routes/skill-graph";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import ReloadIndicator from "./components/ReloadIndicator";
import { SearchProvider } from "./context/SearchContext";

function Layout({ children }) {
  return (
    <SearchProvider>
      <div className="min-h-screen flex flex-col bg-black text-[#f5f5f7]">
        {/* Single subtle glow instead of stacked gradients — calm, Apple-dark backdrop */}
        <div className="pointer-events-none fixed inset-0 bg-[radial-gradient(70%_45%_at_50%_-10%,rgba(140,150,170,0.14),transparent)]"></div>

        <NavBar />
        <ReloadIndicator />
        <main className="relative flex-1 w-full">
          {children}
        </main>
        <Footer />
      </div>
    </SearchProvider>
  );
}

export default function App() {
  return (
    <Layout>
      <Home />
    </Layout>
  );
}

export function AboutLayout() {
  return (
    <Layout>
      <About />
    </Layout>
  );
}

export function FontsLayout() {
  return (
    <Layout>
      <Fonts />
    </Layout>
  );
}

export function SkillGraphLayout() {
  return (
    <Layout>
      <SkillGraph />
    </Layout>
  );
}
